const tools = [
  { name: "ChatGPT", logo: "/logos/chatgpt.png" },
  { name: "Claude", logo: "/logos/claude.png" },
  { name: "Gemini", logo: "/logos/gemini.png" },
  { name: "Genspark", logo: "/logos/genspark.png" },
  { name: "Lovable", logo: "/logos/lovable.png" },
  { name: "HubSpot", logo: "/logos/hubspot.png" },
  { name: "Slack", logo: "/logos/slack.png" },
  { name: "NotebookLM", logo: "/logos/notebooklm.png" },
  { name: "Nanobanana", logo: "/logos/nanobanana.png" },
  { name: "Airtable", logo: "/logos/airtable.png" },
];

const ToolLogoCarousel = () => {
  const doubled = [...tools, ...tools];

  return (
    <section className="py-16 md:py-24 overflow-hidden">
      <div className="max-w-4xl mx-auto text-center mb-12 md:mb-16 px-4">
        <p className="text-sm font-light tracking-[0.2em] text-muted-foreground uppercase">
          Nuestro ecosistema
        </p>
      </div>

      <div
        className="group relative"
        aria-label="Carrusel de herramientas"
      >
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 md:w-40 bg-gradient-to-r from-background to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 md:w-40 bg-gradient-to-l from-background to-transparent" />

        <div className="flex animate-scroll-marquee group-hover:[animation-play-state:paused]">
          {doubled.map((tool, i) => (
            <div
              key={`${tool.name}-${i}`}
              className="flex flex-col items-center justify-center mx-10 md:mx-14 shrink-0 group/item"
            >
              <div className="h-14 w-14 md:h-[72px] md:w-[72px] flex items-center justify-center">
                <img
                  src={tool.logo}
                  alt={tool.name}
                  loading="lazy"
                  width={72}
                  height={72}
                  className={`max-h-full max-w-full object-contain grayscale opacity-40 transition-all duration-500 group-hover/item:grayscale-0 group-hover/item:opacity-100 group-hover/item:scale-110 ${
                    tool.name === "Airtable" ? "scale-75" : ""
                  }`}
                />
              </div>
              <span className="mt-3 text-xs font-light tracking-wide text-muted-foreground whitespace-nowrap transition-colors duration-500 group-hover/item:text-foreground">
                {tool.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ToolLogoCarousel;
